import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { getRouteConfig } from '@ib-core/config/routes.config';
import { EmailAlreadyConfirmedGuard } from '@ib-core/guards/email-already-confirmed.guard';
import { EmailNotConfirmedGuard } from '@ib-core/guards/email-confirmed.guard';
import { IB_ROUTES } from '@ib-enums/routes.enum';

import { AuthenticatedComponent } from './authenticated.component';

const routes: Routes = [
  {
    path: '',
    component: AuthenticatedComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: IB_ROUTES.DASHBOARD },
      {
        path: IB_ROUTES.DASHBOARD,
        // canActivate: [EmailNotConfirmedGuard],
        data: getRouteConfig(IB_ROUTES.DASHBOARD),
        loadChildren: () =>
          import('./dashboard/dashboard.module').then(m => m.DashboardModule),
      },
      // {
      //   path: IB_ROUTES.ACTIVITY,
      //   canActivate: [EmailNotConfirmedGuard],
      //   data: getRouteConfig(IB_ROUTES.ACTIVITY),
      //   loadChildren: () =>
      //     import('./activity/activity.module').then(m => m.ActivityModule),
      // },
      {
        path: IB_ROUTES.WITHDRAW,
        // canActivate: [EmailNotConfirmedGuard],
        data: getRouteConfig(IB_ROUTES.WITHDRAW),
        loadChildren: () =>
          import('./withdraw/withdraw.module').then(m => m.WithdrawModule),
      },
      {
        path: IB_ROUTES.EMAIL_CONFIRMATION,
        // canActivate: [EmailAlreadyConfirmedGuard],
        loadChildren: () =>
          import('./email-confirmation/email-confirmation.module').then(
            m => m.EmailConfirmationModule,
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthenticatedRoutingModule {}
